/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
import React from 'react';

import { getSearchAddressComponents } from '../../../Utilities/utils';

import { LatLng } from '../../../../Modules/Facility/Models/AddFacility.Model';

import GoogleAutoComplete from '../../../../Modules/Facility/Components/AddFacility/GoogleAutoComplete';

import { SearchBarContainer } from '../../../../Modules/Vendor/Components/AllJobs/ModifyGeofence/ModifyGeoFence.Style';
import { GoogleMapLocationSelectorProps } from './GoogleMapLocationSelector.Model';

const GoogleMapSearchBar = ({
  currentLocation,
  setCurrentLocation,
  setCurrentAddress,
  addressExists,
  setAddressExists,
}: GoogleMapLocationSelectorProps): JSX.Element => {
  return (
    <SearchBarContainer>
      <GoogleAutoComplete
        onLocationChange={(location: LatLng) => {
          if (location && typeof location.lat === 'number' && typeof location.lng === 'number') {
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ location: currentLocation }, (results) => {
              if (Array.isArray(results) && results?.length > 0) {
                const addressComponents = getSearchAddressComponents(results);
                setCurrentLocation({ lat: location.lat, lng: location.lng });

                if (addressExists) {
                  setAddressExists?.(false);
                }
                setCurrentAddress(addressComponents);
                return results;
              }
            });
          }
        }}
        initialCenter={{
          lat: currentLocation.lat,
          lng: currentLocation.lng,
        }}
      />
    </SearchBarContainer>
  );
};

export default GoogleMapSearchBar;
